import { resolveImagePath } from '@/utils/imageMap';

export function RCA1510ProductShowcase() {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-rcallen-primary-blue uppercase font-arial mb-2">
          RCA1510 DIGITAL HEADING INDICATOR
        </h2>
      </div>

      {/* Main Content Layout */}
      <div className="flex flex-col lg:flex-row gap-8">
        
        {/* Product Image */}
        <div className="lg:w-1/2">
          <div className="bg-gray-50 rounded-lg p-6 text-center">
            <img
              src={resolveImagePath('/images/RCA1510.jpg')}
              alt="RCA1510 Digital Heading Indicator"
              className="w-full max-w-md mx-auto rounded-lg shadow-md"
            />
            <div className="mt-4 text-center">
              <div className="font-bold text-rcallen-primary-blue font-arial">
                RCA1510-3
              </div>
            </div>
          </div>
        </div>

        {/* Product Description and Features */}
        <div className="lg:w-1/2">
          
          {/* Product Description */}
          <div className="mb-6">
            <p className="text-rcallen-black font-arial leading-relaxed">
              Our <span className="font-bold">RCA1510</span> is the perfect companion to the <span className="font-bold">RCA2610</span> Digital Attitude Indicator. 
              The display has multiple options which can show the Magnetic Heading (MAG HDG) or GPS Ground Track Heading (GND TRK) 
              individually or both simultaneously.
            </p>
          </div>

          {/* Features List */}
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Left Column Features */}
              <div>
                <ul className="space-y-2 text-sm font-arial text-rcallen-black">
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>OPTIONAL BATTERY BACKUP</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>NO SPECIAL CONNECTIONS</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>EASY INSTALLATION</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>MULTI-VOLT OPERATION</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>FULLY FAA CERTIFIED</span>
                  </li>
                </ul>
              </div>
              
              {/* Right Column Features */}
              <div>
                <ul className="space-y-2 text-sm font-arial text-rcallen-black">
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>TOTALLY SELF-CONTAINED</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>QUICK-SET HEADING BUG</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>INTERNAL MAGNETOMETER</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>OPTIONAL INTERNAL GPS</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                    <span>TWO YEAR LIMITED WARRANTY</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* More Information Link */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center justify-center">
              <a 
                href="/downloads" 
                className="inline-flex items-center gap-3 text-rcallen-primary-blue hover:text-blue-700 transition-colors"
              >
                <div className="w-8 h-8 bg-rcallen-primary-blue text-white rounded-full flex items-center justify-center text-sm">
                  i
                </div>
                <div className="text-center">
                  <div className="text-xs font-arial">CLICK HERE FOR MORE</div>
                  <div className="text-xs font-arial font-bold">INFORMATION</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Technical Specifications */}
      <div className="mt-8 p-6 bg-gray-50 rounded-lg">
        <h4 className="text-lg font-bold text-rcallen-primary-blue font-arial mb-4 text-center">
          TECHNICAL SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm font-arial">
          <div>
            <span className="font-bold text-rcallen-black">Display:</span>
            <span className="text-rcallen-black ml-2">MAG HDG / GPS GND TRK</span>
          </div>
          <div>
            <span className="font-bold text-rcallen-black">Size:</span>
            <span className="text-rcallen-black ml-2">3.125" Standard</span>
          </div>
          <div>
            <span className="font-bold text-rcallen-black">Power:</span>
            <span className="text-rcallen-black ml-2">Multi-Volt Operation</span>
          </div>
          <div>
            <span className="font-bold text-rcallen-black">Certification:</span>
            <span className="text-rcallen-black ml-2">FAA Approved</span>
          </div>
          <div>
            <span className="font-bold text-rcallen-black">Warranty:</span>
            <span className="text-rcallen-black ml-2">2 Year Limited</span>
          </div>
          <div>
            <span className="font-bold text-rcallen-black">Installation:</span>
            <span className="text-rcallen-black ml-2">Standard Panel Cutout</span>
          </div>
        </div>
      </div>

      {/* Certification Logo */}
      <div className="mt-8 text-center">
        <div className="inline-block bg-gray-100 px-4 py-2 rounded-lg">
          <span className="text-sm font-arial text-rcallen-black">✓ FAA CERTIFIED</span>
        </div>
      </div>
    </div>
  );
}